// extracted by mini-css-extract-plugin
export default {"header":"ScrollTable_header__gORwx","scrolled":"ScrollTable_scrolled__MLf8G"};